<template>
  <transition name="fade">
    <div class="phrase-overlay" v-if="member_add_modal">
      <user-token-site-name :user-token="user_token" @updateSiteInfo="updateSiteInfo" />
      <div class="create-phrase-wrap">
        <div class="list-create">
          <div class="newmessage-title">
            メンバーアカウントの作成
            <div class="flex-space"></div>
            <div class="newmessage-button" @click="closeModal()">
              <font-awesome-icon :icon="['fal', 'times']" />
            </div>
          </div>

          <div class="member-link-wrap">
            <div style="margin-bottom:20px; line-height:20px">下記の招待リンクから貴社メンバーのアカウントが無制限に作成可能です。アカウント作成を行いたいメンバーにこのリンクを共有してください。</div>
            <div style="margin-bottom:5px; font-weight:700">招待リンクURL</div>
            <div class="member-link-area">
              <div class="member-link">{{ root }}/member_invite/{{ member_link }}</div>
              <el-button type="primary" size="small" style="margin-left:10px" @click="copyLink()"> <font-awesome-icon :icon="['far', 'link']" style="margin-right: 3px;" />リンクをコピー </el-button>
            </div>
          </div>

          <div style="margin:20px 0">
            <ul class="ul-exclamation">
              <li>
                この招待リンクは<span style="font-weight:700">{{ expiration_at }}</span
                >まで有効です
              </li>
              <li>この招待リンクは管理者のみが発行可能です</li>
            </ul>
          </div>

          <div class="list-create-footer">
            <div class="pointer" style="font-size:11px; margin-left:10px; color: #f56c6c; font-weight:700" @click="resetLink()">
              招待リンクをリセットする
              <el-tooltip content="招待リンクをリセットすると、現在の招待リンクは無効となります">
                <font-awesome-icon :icon="['fas', 'question-circle']" style="margin-left: 3px;" />
              </el-tooltip>
            </div>
            <div class="flex-space"></div>
            <el-button @click="closeModal()">閉じる</el-button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import UserTokenSiteName from "@/components/oem/UserTokenSiteInfo.vue";
const root = process.env.VUE_APP_API;
const memberLinkAPI = root + "/api/member/member_link";

export default {
  name: "memberAdd",
  props: ["member_add_modal"],
  components: {
    UserTokenSiteName,
  },
  provide() {
    return {
      updateSiteInfo: this.updateSiteInfo
    }
  },
  data() {
    return {
      member_link: "",
      expiration_at: "",
      root: root
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user_token() {
      return this.$store.state.user_token;
    },
  },
  mounted() {
  },
  methods: {
    loadMemberLink() {
      var params = new URLSearchParams();
      params.append("token", this.token);
      this.axios
        .post(memberLinkAPI, params)
        .then((response) => {
          this.member_link = response.data.member_link;
          this.expiration_at = response.data.expiration_at;
        })
        .catch(() => {});
    },
    resetLink() {
      var params = new URLSearchParams();
      params.append("token", this.token);
      params.append("reset", true);
      this.axios
        .post(memberLinkAPI, params)
        .then((response) => {
          this.member_link = response.data.member_link;
          this.expiration_at = response.data.expiration_at;
          this.$message({
            type: "success",
            offset: 7,
            showClose: true,
            message: "招待リンクをリセットしました",
          });
        })
        .catch(() => {});
    },
    copyLink() {
      var text = this.root + "/member_invite/"+this.member_link
      navigator.clipboard
        .writeText(text)
        .then(() => {
          this.$message({
            type: "success",
            offset: 7,
            showClose: true,
            message: "招待リンクがコピーされました",
          });
        })
        .catch(() => {
          this.$message({
            type: "error",
            offset: 7,
            showClose: true,
            message: "招待リンクのコピーに失敗しました",
          });
        });
    },
    closeModal() {
      this.$emit("update:member_add_modal", false);
    },
    updateSiteInfo({siteUrl}) {
      this.root = siteUrl;
    },
  },
  filters: {},
  watch: {
    member_add_modal(){
      if (this.member_add_modal==true) {
        this.loadMemberLink();
      }
    }
  },
};
</script>
